import { render, staticRenderFns } from "./TemSaudeLote.vue?vue&type=template&id=0c4178b8"
import script from "./TemSaudeLote.vue?vue&type=script&lang=js"
export * from "./TemSaudeLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports